import { SegmentationType } from '../enums';
import { SubmissionState } from '../enums/submission-state.enum';
import { WorkflowType } from '../enums/workflow-type.enum';
import { WorkflowVisibility } from '../types/workflow-visibility.type';
import { ModuleV1Read, VersionReadModel } from './module-v1-read.model';
import { UserInfo } from './user-info.model';
import { WorkflowCategoryV1Read } from './workflow-category-v1-read';
import { WorkflowSpecificationModel } from './workflow-specification';

export interface WorkflowV1Read extends WorkflowV1Run {
    imageUrl?: string;
    createdAt: string;
    sortOrderDate: string;
    category?: WorkflowCategoryV1Read;
    images: string[];
    author?: UserInfo; // attached in code, not part of backend response
}

export interface WorkflowV1Run {
    id: string;
    producerId: string;
    title: string;
    summary: string;
    description: string;
    visibility: WorkflowVisibility;
    specification: WorkflowSpecificationModel;
    usedModuleVersions: VersionReadModel[];
    usedModules: ModuleV1Read[];
    type: WorkflowType;
    segmentationTypeSupported?: SegmentationType;
    isDefaultForType?: boolean;
    isFeatured: boolean;
    mlVersion?: number;
    createdAt?: string;
}

export class WorkflowSubmissionProducerRead {
    id: string;
    createdAt: string;
    modifiedAt: string;
    state: SubmissionState;
    commentToReviewer: string;
    commentToProducer: string;
}

export class WorkflowV1Save {
    title: string;
    description: string;
    summary: string;
    specification: WorkflowSpecificationModel;
    type: WorkflowType;
    segmentationTypeSupported?: SegmentationType;
    isDefaultForType?: boolean;
    isFeatured?: boolean;
    mlVersion?: number;
    successorWorkflowIds?: string[];

    constructor(workflow: WorkflowV1Read) {
        this.title = workflow.title;
        this.description = workflow.description;
        this.summary = workflow.summary;
        this.specification = workflow.specification;
        this.type = workflow.type;
        this.isDefaultForType = workflow.isDefaultForType;
        this.isFeatured = workflow.isFeatured;
        this.mlVersion = workflow.mlVersion;
        this.segmentationTypeSupported = workflow.segmentationTypeSupported;
    }
}
